import React from 'react';
import '../About/about.css';
import image from '../Events/image.jpeg';
import Gallery from '../Gallery/gallery';
import img from '../../Components/Images/image.webp';
import img1 from '../../Components/Images/image1.webp';
import img2 from '../../Components/Images/image2.webp';
import img3 from '../../Components/Images/image3.webp';
import img4 from '../../Components/Images/image4.webp';
import img5 from '../../Components/Images/image5.webp';

const Bhawishyam = () => {
    const images = [
        {
            src: img,
            alt: "Image"
        },
        {
            src: img1,
            alt: "Image"
        }, {
            src: img2,
            alt: "Image"
        }, {
            src: img3,
            alt: "Image"
        }, {
            src: img4,
            alt: "Image"
        }, {
            src: img5,
            alt: "Image"
        },

    ]
    return (
        <>
            <section className="about">
                <div className="main">
                    <img src={image} alt="About Us" />
                    <div className="all-text">
                        <h1>Bhawishyam</h1>
                        <p>
                            In a celebration of intellectual prowess and cultural diversity, Ozone, marked its first-ever collaboration with Horizon Science Society. The three-day extravaganza, aptly named "Bhavishyam," unfolded as a tapestry of knowledge, creativity, and camaraderie.
                            The event kicked off with a diverse array of workshops that captivated the participants, delving into realms from practical life-saving skills to the intricacies of space exploration. Notably, Dr. SK Singh led an insightful CPR session, imparting valuable knowledge that extends beyond the academic realm.
                        </p>
                        <p>
                            Mr. Aditya Rallapalli, an esteemed guest, shared illuminating insights on the much-anticipated Chandrayaan 3 mission. His expertise added a layer of intellectual excitement, fostering an environment where curiosity thrived.
                            The intellectual vigor continued with engaging chess tournaments, challenging the strategic minds of participants. As the chess pieces moved across the board, so did the intellectual energies of those involved.
                        </p>
                        <p>
                            A pivotal moment in Bhavishyam was the thought-provoking panel discussion on "The Future of Science in India," organized collaboratively by Ozone Student Society and Horizon Science Society. Dr. Prashant Rawat, a Senior Associate Professor, skillfully moderated the discussion, steering conversations among experts from interdisciplinary fields. The panel's insights resonated with the audience, offering a glimpse into the future of scientific advancements in India.
                            Beyond the academic rigors, Bhavishyam embraced the spirit of fun and adventure. A chess tournament and a treasure hunt competition brought participants together in friendly competition, fostering a sense of unity and shared enjoyment.
                            The grand finale, KalaSangam, unfolded as a cultural extravaganza that transcended boundaries. Band performances echoed through the venue, dance performances mesmerized the audience, and the presidents and associate secretaries of Ozone and Horizon, in their brief introductions, expressed gratitude for the collaborative effort that brought Bhavishyam to life.
                        </p>
                    </div>
                </div>
            </section>
            <Gallery images={images} />
        </>
    );
};

export default Bhawishyam;
